<div class='notice-card'>
  <div class='notice-card-inner'>
    <i class='{{ icon }}'></i>
    <p>{{ content }}</p>
  </div>
</div>
